module.exports = __webpack_public_path__ + "static/carbon_card_preview-48508164afa9c4a45bcc8618880747ba.jpg";